import { useIonModal } from '@ionic/react'

import { ManagementViewSelectModal } from '@apps-common/apps/portal/pages/management/modals'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

export const ManagementViewSelectButton: React.FC = () => {
  const [present, dismiss] = useIonModal(ManagementViewSelectModal, {
    componentProps: {},
    onDismiss: (data: string, role: string) => {
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return (
    <ButtonRoundSm
      type='button'
      className='action-brand'
      callback={() =>
        present({
          enterAnimation: modalSlideUpEnterAnimation,
          leaveAnimation: modalSlideUpLeaveAnimation,
          backdropDismiss: true
        })
      }
      tooltip={{
        id: `management-category-selection-tooltip`,
        message: 'Management category'
      }}
    >
      <commonIcons.managementStack />
    </ButtonRoundSm>
  )
}
